import React from 'react';
import { CATEGORIES, IMAGES } from '../data';
import { Reveal } from './Reveal';

// Duplicate the list so the drifting band loops seamlessly.
const BAND = [...CATEGORIES, ...CATEGORIES];
export function Categories() {
  return <section id="utbud" className="w-full bg-warm py-28 md:py-40" data-id="element-46" data-mp="mebu99zodv5z">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-47" data-mp="hfifle8njy48">
        <div className="grid items-end gap-10 md:grid-cols-2" data-id="element-48" data-mp="hgtgn6apqrrn">
          <Reveal data-id="element-49" data-mp="1f16297fb322k">
            <p className="mb-6 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-50" data-mp="1f1pimjpb5ieh">
              Vad du hittar hos oss
            </p>
            <h2 className="font-display text-4xl font-light leading-tight text-brun md:text-5xl" data-id="element-51" data-mp="15cefddp3r7yi">
              Allt samlat på ett ställe.
            </h2>
          </Reveal>
          <Reveal delay={0.15} data-id="element-52" data-mp="10bi8cr9gf5ov">
            <p className="max-w-md text-lg leading-relaxed text-brun-soft md:justify-self-end" data-id="element-53" data-mp="1xtidkjnxtdou">
              Från bagerier och specialkaffe till privatkockar och lokala producenter – ett noggrant
              utvalt urval av Smålands bästa.
            </p>
          </Reveal>
        </div>
      </div>

      {/* Drifting categories band */}
      <div className="marquee-mask mt-16 overflow-hidden md:mt-20" data-id="element-54" data-mp="3b3k7jog5bpsk">
        <div className="flex w-max animate-drift gap-6 pr-6" data-id="element-55" data-mp="2wfz2hozpngi0">
          {BAND.map((c, i) => <span key={`${c}-${i}`} className="whitespace-nowrap font-display text-3xl font-light text-brun/70 md:text-4xl" data-id="element-56" data-mp="31diioufyy3cl" data-mpi={i}>
              {c}
              <span className="ml-6 text-terrakotta" data-id="element-57" data-mp="2rfuj9r7f47o3">·</span>
            </span>)}
        </div>
      </div>

      {/* Experience imagery strip */}
      <div className="mx-auto mt-20 grid max-w-7xl grid-cols-2 gap-4 px-6 md:mt-28 md:grid-cols-4 md:px-10" data-id="element-58" data-mp="2di5yskh9j2jk">
        {[{
        src: IMAGES.ingredients,
        alt: 'Närbild på färska säsongsråvaror'
      }, {
        src: IMAGES.cheeseCharcuterie,
        alt: 'Ost- och charkbricka'
      }, {
        src: IMAGES.foodTruck,
        alt: 'Food truck på en sommarfest'
      }, {
        src: IMAGES.chefPlating,
        alt: 'Privatkock som lägger upp en rätt'
      }].map((img, i) => <Reveal key={img.src} delay={i * 0.1} data-id="element-59" data-mp="a7jgee0eurby" data-mpi={i}>
            <div className="overflow-hidden rounded-sm" data-id="element-60" data-mp="a9vycr6651p0">
              <img src={img.src} alt={img.alt} className="h-56 w-full object-cover transition-transform duration-700 hover:scale-105 md:h-72" data-id="element-61" data-mp="59rd6nubfisg" />
            </div>
          </Reveal>)}
      </div>
    </section>;
}